import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import router from "./router";
import { Provider } from "react-redux";
import store from "./Redux/store";
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import modernTheme from './theme/modernTheme';
import "./App.css";
import { ToastContainer } from "react-toastify"; // ✅ Correct import
import "react-toastify/dist/ReactToastify.css"; // ✅ Required for styles

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <ThemeProvider theme={modernTheme}>
      <CssBaseline />
      <ToastContainer /> {/* ✅ Renders toast notifications */}
      <RouterProvider router={router} />
    </ThemeProvider>
  </Provider>
);
